import { render } from "./Portfolio.vue?vue&type=template&id=1e4c965e&ts=true"
import script from "./Portfolio.vue?vue&type=script&lang=ts"
export * from "./Portfolio.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__